module.exports = __webpack_public_path__ + "static/media/icon-font-bold.8875d23f.svg";